export const SearchParamKeys = {
  // Common
  COLOR_THEME: 'color-mode', // Same key as website
  OPEN_MODAL: 'open_modal',
  REDIRECT_PATH: 'redirect_path',
  REDIRECT_MODAL: 'redirect_modal',
  INVOICE_ID: 'invoice_id',

  // Table state
  pagination: 'page',
  sorting: 'sort',
  globalFilter: 'query',
  columnFilterClient: 'client',
  columnFilterBrand: 'brand',
  columnFilterYears: 'years',
  columnFilterQuarters: 'quarters',
  columnFilterStatuses: 'statuses',
  columnFilterTemplateType: 'type',

  // Community
  FILTER_SEARCH: 'search',
  FILTER_ACTIVITY_ID: 'activityId',
  FILTER_OPEN_TO_WORK: 'available',
  FILTER_REGION: 'region',

  // Job posts
  FILTER_LOCATION_TYPE: 'location_type',

  // Forum
  FILTER_FORUM_TAG: 'tag',

  // Registration
  REGISTRATION_ENTERPRISE_NUMBER: 'enterprise_number',
  REGISTRATION_EMAIL_ADDRESS: 'email',
  REGISTRATION_PHONE_NUMBER: 'phone',
  REGISTRATION_REFERRAL_CODE: 'referral_code',

  // LeadJourney
  LEAD_JOURNEY_CLICK_ID: 'lj_click_id', // Added by LeadJourney when linking from the website

  // Authentication
  RESET_PASSWORD_TOKEN: 'token',

  // External
  BILLIT_CODE: 'code',
} as const;

export const SearchParamModals = {
  // Invoices & quotations
  ADD_PRODUCT: 'add_product',
  START_FOLLOW_UP: 'start_follow_up',

  // Settings
  ADD_NUMBERING_SERIES: 'add_numbering_series',
} as const;

export type TSearchParamModals = (typeof SearchParamModals)[keyof typeof SearchParamModals];

export const AnchorTargets = {
  CONTACT_EMAILS: 'emails',

  SETTINGS_PROFILE_INFO: 'profile-info',
  SETTINGS_PROFILE_COMMUNITY: 'community',
  SETTINGS_PROFILE_PASSWORD: 'password',

  SETTINGS_EMAIL_SETTINGS: 'email-settings',

  SETTINGS_INVOICE_THEME: 'invoice-theme',
  SETTINGS_INVOICE_NUMBERING_SERIES: 'numbering-series',
  SETTINGS_INVOICE_CUSTOM_CONDITIONS: 'custom-conditions',

  SETTINGS_COMPANY_INFO: 'company-info',
  SETTINGS_COMPANY_ACTIVITIES: 'activities',
  SETTINGS_COMPANY_FINANCIAL: 'financial-details',
  SETTINGS_COMPANY_VAT_REGULATION: 'vat-regulation',
  SETTINGS_COMPANY_BRANDS: 'brands',
  SETTINGS_COMPANY_ACCOUNTANT: 'accountant',

  SETTINGS_INTEGRATIONS_AUTO_FORWARDING: 'auto-forwarding',
  SETTINGS_INTEGRATIONS_EXTERNAL_SERVICES: 'external-services',
  SETTINGS_INTEGRATIONS_PEPPOL: 'peppol',
} as const;
